/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
import useMultiLanguageInput from '../../utils/useMultiLanguageInput';
import FormFieldText from './FormFieldText';

const FormFieldTextMultiLanguage = forwardRef(
  (
    {
      input,
      meta,
      testId,
      isMultiLanguage,
      id,
      name,
      type,
      required,
      autoComplete,
      label,
      disabled,
      readOnly,
      showValueOnly,
      placeholder,
      size,
      suffix,
      schema,
      minLength,
      maxLength,
    },
    ref,
  ) => {
    const multiLanguage = useMultiLanguageInput({
      input,
      isMultiLanguage,
    });

    return (
      <FormFieldText
        data-testid={testId}
        ref={ref}
        input={isMultiLanguage ? multiLanguage.input : input}
        meta={meta}
        id={id}
        name={name}
        type={type}
        required={required}
        autoComplete={autoComplete}
        label={label}
        disabled={disabled}
        readOnly={readOnly}
        showValueOnly={showValueOnly}
        placeholder={placeholder}
        size={size}
        suffix={suffix}
        schema={schema}
        minLength={minLength}
        maxLength={maxLength}
        isNewPresentation
        multiLanguageProps={
          isMultiLanguage && {
            languagesValues: input.value,
            language: multiLanguage.language,
            onSelectLanguage: multiLanguage.handleSelectLanguage,
          }
        }
      />
    );
  },
);

FormFieldTextMultiLanguage.propTypes = {};

export default FormFieldTextMultiLanguage;
